import {useTranslation} from "react-i18next";

const useWinnersTable = () => {
    const {t} = useTranslation()

    const headCells = [
        {
            label: t('entry_id'),
        },
        {
            label: t('winner'),
        },
        {
            label: '',
        },
    ]
    return {headCells}
}

export default useWinnersTable
